"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _draftJs = require("draft-js");

var _draftExtend = require("draft-extend");

var _default = _react.default.createClass({
  displayName: "ReadOnlyEditor",
  propTypes: {
    title: _react.PropTypes.string.isRequired,
    editorState: _react.PropTypes.instanceOf(_draftJs.EditorState).isRequired,
    configuredPlugins: _react.PropTypes.func.isRequired,
    onEditorStateChange: _react.PropTypes.func.isRequired
  },
  componentWillMount: function componentWillMount() {
    this.buildEditor(this.props.configuredPlugins);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.configuredPlugins !== this.props.configuredPlugins) {
      this.buildEditor(nextProps.configuredPlugins);
    }
  },
  buildEditor: function buildEditor(configuredPlugins) {
    this.EditorWithPlugins = configuredPlugins(_draftExtend.Editor);
  },
  render: function render() {
    var _this$props = this.props,
        title = _this$props.title,
        editorState = _this$props.editorState,
        onEditorStateChange = _this$props.onEditorStateChange;
    return _react.default.createElement("div", {
      className: "playbooks-modal-body"
    }, _react.default.createElement("h4", null, title), _react.default.createElement(this.EditorWithPlugins, {
      editorState: editorState,
      readOnly: true,
      onChange: onEditorStateChange
    }));
  }
});

exports.default = _default;
module.exports = exports.default;